import {useQuery} from 'react-query';
import {STORAGE_OBJECTS_QUERY_KEY} from '../init/constants';
import {APIClient} from '../backend/ApiClient';
import {useContext} from 'react';
import {AuthContext} from '../context/AuthContext';
import {dynamicConfig} from '../init/config';

export const useGetStorageObjects = (
    country: string,
    language: string,
    path: string,
    page: number,
    sortOrder: string,
    search: string | null,
    fileId: string | null,
    fileTypes: string[] | [] | null,
    noOfDays: number,
    isFavorite: boolean,
    isPublic: boolean,
    objectType: string
) => {
    const {isAuthenticated} = useContext(AuthContext);
    const apiClient = APIClient();

    return useQuery(
        [STORAGE_OBJECTS_QUERY_KEY, country, language, path, page, sortOrder, search, fileId, fileTypes, noOfDays, isFavorite, isPublic, objectType],
        () => apiClient.getStorageObjects(country, language, path, page, sortOrder, search, fileId, fileTypes, noOfDays, isFavorite, isPublic, objectType),
        {
            retry: 1,
            enabled: dynamicConfig.DLS_AUTHENTICATION_ACTIVE ? isAuthenticated : true
        }
    );
};
